module.exports = __webpack_public_path__ + "media/weird.1de6684f.wav";